"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMethod;

var _util = require("@polkadot/util");

// Copyright 2017-2019 @polkadot/jsonrpc authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function createMethod(section, method, _ref) {
  let description = _ref.description,
      _ref$isDeprecated = _ref.isDeprecated,
      isDeprecated = _ref$isDeprecated === void 0 ? false : _ref$isDeprecated,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
      _ref$isSigned = _ref.isSigned,
      isSigned = _ref$isSigned === void 0 ? false : _ref$isSigned,
      params = _ref.params,
      pubsub = _ref.pubsub,
      type = _ref.type;
  return {
    description,
    isDeprecated,
    isHidden,
    isSigned,
    isSubscription: !(0, _util.isUndefined)(pubsub),
    method,
    params,
    pubsub: pubsub || ['', '', ''],
    section,
    type
  };
}